import { TApplicationState } from '../../types/redux';

export function getGaLabel(state: TApplicationState): string {
  const { newbuilding } = state;

  if (!newbuilding || !newbuilding.gaLabel) {
    return '';
  }

  return newbuilding.gaLabel;
}
